import React, { useState } from "react";
import { navigationData } from "../../screens/Home/data";
import { NavLink } from "react-router-dom";
// import logo from "../../assets/img/logo_white.png";
import logo from "../../assets/img/logo_white.png";

import { ServicesList, serviceList } from "../../utils/Dummy";

function Footer() {
  const [selected, setSelected] = useState(null);
  const [selectedIndx, setSelectedIndx] = useState(null);

  const onSelect = (item, indx) => {
    if (item === selected) {
      setSelected(null);
      setSelectedIndx(null);
    } else {
      setSelected(item);
      setSelectedIndx(indx);
    }
  };
  return (
    <footer>
      {/* <div className="bg-[url(./assets/img/bg.png)] text-gray-200 p-5"> */}
      <div className="bg-black text-gray-200 p-5">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
            <div className="md:mb-5 text-center">
              <img
                src={logo}
                alt=""
                className="md:h-[40%] lg:h-[35%] mt-3 ml-1"
              />
              <div className="grid grid-cols-4 gap-1 py-4 px-6">
                <a
                  href="https://www.linkedin.com/in/truwa-infotech-a94a162a5/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button
                    type="button"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                    className="mb-2 inline-block rounded-full p-3 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg w-[40px] bg-[#1877f2]"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z" />
                    </svg>
                  </button>
                </a>

                <a
                  href="https://www.instagram.com/truwa_/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button
                    type="button"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                    class="mb-2 inline-block rounded-full p-3 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg w-[40px]"
                    style={{ background: "#c13584" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      fill="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                    </svg>
                  </button>
                </a>

                <a
                  href="https://wa.me/919289337225"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button
                    type="button"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                    class="mb-2 inline-block rounded-full p-3 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg w-[40px]"
                    style={{ background: "#66e066" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 32 32"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16 31C23.732 31 30 24.732 30 17C30 9.26801 23.732 3 16 3C8.26801 3 2 9.26801 2 17C2 19.5109 2.661 21.8674 3.81847 23.905L2 31L9.31486 29.3038C11.3014 30.3854 13.5789 31 16 31ZM16 28.8462C22.5425 28.8462 27.8462 23.5425 27.8462 17C27.8462 10.4576 22.5425 5.15385 16 5.15385C9.45755 5.15385 4.15385 10.4576 4.15385 17C4.15385 19.5261 4.9445 21.8675 6.29184 23.7902L5.23077 27.7692L9.27993 26.7569C11.1894 28.0746 13.5046 28.8462 16 28.8462Z"
                        fill="#BFC8D0"
                      />
                      <path
                        d="M28 16C28 22.6274 22.6274 28 16 28C13.4722 28 11.1269 27.2184 9.19266 25.8837L5.09091 26.9091L6.16576 22.8784C4.80092 20.9307 4 18.5589 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z"
                        fill="url(#paint0_linear_87_7264)"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16 30C23.732 30 30 23.732 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 18.5109 2.661 20.8674 3.81847 22.905L2 30L9.31486 28.3038C11.3014 29.3854 13.5789 30 16 30ZM16 27.8462C22.5425 27.8462 27.8462 22.5425 27.8462 16C27.8462 9.45755 22.5425 4.15385 16 4.15385C9.45755 4.15385 4.15385 9.45755 4.15385 16C4.15385 18.5261 4.9445 20.8675 6.29184 22.7902L5.23077 26.7692L9.27993 25.7569C11.1894 27.0746 13.5046 27.8462 16 27.8462Z"
                        fill="white"
                      />
                      <path
                        d="M12.5 9.49989C12.1672 8.83131 11.6565 8.8905 11.1407 8.8905C10.2188 8.8905 8.78125 9.99478 8.78125 12.05C8.78125 13.7343 9.52345 15.578 12.0244 18.3361C14.438 20.9979 17.6094 22.3748 20.2422 22.3279C22.875 22.2811 23.4167 20.0154 23.4167 19.2503C23.4167 18.9112 23.2062 18.742 23.0613 18.696C22.1641 18.2654 20.5093 17.4631 20.1328 17.3124C19.7563 17.1617 19.5597 17.3656 19.4375 17.4765C19.0961 17.8018 18.4193 18.7608 18.1875 18.9765C17.9558 19.1922 17.6103 19.083 17.4665 19.0015C16.9374 18.7892 15.5029 18.1511 14.3595 17.0426C12.9453 15.6718 12.8623 15.2001 12.5959 14.7803C12.3828 14.4444 12.5392 14.2384 12.6172 14.1483C12.9219 13.7968 13.3426 13.254 13.5313 12.9843C13.7199 12.7145 13.5702 12.305 13.4803 12.05C13.0938 10.953 12.7663 10.0347 12.5 9.49989Z"
                        fill="white"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_87_7264"
                          x1="26.5"
                          y1="7"
                          x2="4"
                          y2="28"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#5BD066" />
                          <stop offset="1" stop-color="#27B43E" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </button>
                </a>

                <a
                  href="https://app.lottiefiles.com/?utm_medium=web&utm_source=navigation-dashboard"
                  target="_blank"
                >
                  <button
                    type="button"
                    data-te-ripple-init
                    data-te-ripple-color="light"
                    class="mb-2 inline-block rounded-full p-3 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg w-[40px]"
                    style={{ background: "#ffff" }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-4 w-4"
                      viewBox="0 0 60 61"
                      fill="none"
                    >
                      <rect
                        x="0.498825"
                        y="0.499999"
                        width="58.4088"
                        height="58.4088"
                        rx="7.5"
                        transform="matrix(1 0 -0.00234907 0.999997 0.14073 0.968751)"
                        fill="#00DDB3"
                      />
                      <path
                        d="M41.6404 8.74341H19.9063C13.7577 8.74341 8.77333 13.7278 8.77333 19.8763V41.6105C8.77333 47.759 13.7577 52.7434 19.9063 52.7434H41.6404C47.7889 52.7434 52.7733 47.759 52.7733 41.6105V19.8763C52.7733 13.7278 47.7889 8.74341 41.6404 8.74341Z"
                        fill="#00DDB3"
                      />
                      <path
                        d="M42.5345 18.7434C34.7496 18.7434 31.8648 24.0867 29.5452 28.3792L28.0299 31.1255C25.5736 35.6777 23.7385 38.4449 19.0092 38.4449C18.7156 38.4449 18.4248 38.5005 18.1536 38.6085C17.8823 38.7165 17.6358 38.8748 17.4282 39.0744C17.2206 39.274 17.0558 39.5109 16.9435 39.7717C16.8311 40.0324 16.7733 40.3119 16.7733 40.5942C16.7742 41.1639 17.01 41.7101 17.4291 42.113C17.8482 42.5159 18.4165 42.7426 19.0092 42.7434C26.7971 42.7434 29.6819 37.4001 32.0015 33.1076L33.5138 30.3613C35.9731 25.8091 37.8083 23.0419 42.5345 23.0419C42.8283 23.0423 43.1194 22.987 43.391 22.8792C43.6626 22.7713 43.9095 22.6131 44.1174 22.4135C44.3253 22.2139 44.4904 21.9768 44.6029 21.7158C44.7155 21.4549 44.7733 21.1752 44.7733 20.8927C44.7725 20.3224 44.5363 19.7757 44.1165 19.3727C43.6967 18.9698 43.1277 18.7434 42.5345 18.7434Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </a>
                {/* <button
                  type="button"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="mb-2 inline-block rounded-full p-3 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg w-[40px]"
                  style={{ background: "#1769ff" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14h-8.027c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z" />
                  </svg>
                </button>
                <button
                  type="button"
                  data-te-ripple-init
                  data-te-ripple-color="light"
                  className="mb-2 inline-block rounded-full p-3 text-xs font-medium uppercase leading-normal text-white shadow-md transition duration-150 ease-in-out hover:shadow-lg focus:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg w-[40px]"
                  style={{ background: "#ea4c89" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 0c-6.628 0-12 5.373-12 12s5.372 12 12 12 12-5.373 12-12-5.372-12-12-12zm9.885 11.441c-2.575-.422-4.943-.445-7.103-.073-.244-.563-.497-1.125-.767-1.68 2.31-1 4.165-2.358 5.548-4.082 1.35 1.594 2.197 3.619 2.322 5.835zm-3.842-7.282c-1.205 1.554-2.868 2.783-4.986 3.68-1.016-1.861-2.178-3.676-3.488-5.438.779-.197 1.591-.314 2.431-.314 2.275 0 4.368.779 6.043 2.072zm-10.516-.993c1.331 1.742 2.511 3.538 3.537 5.381-2.43.715-5.331 1.082-8.684 1.105.692-2.835 2.601-5.193 5.147-6.486zm-5.44 8.834l.013-.256c3.849-.005 7.169-.448 9.95-1.322.233.475.456.952.67 1.432-3.38 1.057-6.165 3.222-8.337 6.48-1.432-1.719-2.296-3.927-2.296-6.334zm3.829 7.81c1.969-3.088 4.482-5.098 7.598-6.027.928 2.42 1.609 4.91 2.043 7.46-3.349 1.291-6.953.666-9.641-1.433zm11.586.43c-.438-2.353-1.08-4.653-1.92-6.897 1.876-.265 3.94-.196 6.199.196-.437 2.786-2.028 5.192-4.279 6.701z" />
                  </svg>
                </button> */}
              </div>
            </div>
            <div className="md:mb-5">
              <h4 className="text-2xl pb-4">Company</h4>
              <p className="text-gray-300">
                Noida, India <br />
                <strong>Phone:</strong> +91 9289337225 <br />
                <strong>Email:</strong> truwainfotech@gmail.com <br />
              </p>
            </div>
            <div className="md:mb-5 md:mx-5">
              <h4 className="text-2xl pb-4">Useful Links</h4>

              <ul className="text-gray-300 pl-2">
                <li className="pb-2">
                  <i className="fa fa-chevron-right"></i>
                  <NavLink to={`/`} className="hover:text-lime-400">
                    {" "}
                    Home
                  </NavLink>
                </li>

                {navigationData.map((item, index) => (
                  <li key={index} className="pb-2">
                    <i className="fa fa-chevron-right"></i>
                    <NavLink
                      to={`/${item.route}`}
                      className="hover:text-lime-400"
                    >
                      {" "}
                      {item.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <div className="md:mb-5 md:mx-5">
              <h2 className="text-2xl pb-4">Our Services</h2>
              <ul className="text-gray-300 pl-2">
                {serviceList.map((item, index) => (
                  <li
                    key={index}
                    className="pb-2"
                    onClick={() => {
                      onSelect(item.name, index);
                    }}
                  >
                    <i
                      className={
                        item.name === selected
                          ? "fa fa-chevron-down"
                          : "fa fa-chevron-right"
                      }
                    ></i>
                    <p className="cursor-pointer inline ms-1 hover:text-lime-400">
                      {item.title}
                    </p>
                    {selected &&
                      selectedIndx === index &&
                      ServicesList[selected].map((ite) => (
                        <ul className="text-gray-300 pl-8" key={ite.name}>
                          <li className="pb-1 hover:text-lime-500">
                            <NavLink
                              to={`/services`}
                              className="hover:text-lime-400"
                            >
                              {ite.name}
                            </NavLink>
                          </li>
                        </ul>
                      ))}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div>
          <div className="text-center text-lg">
            <h2>© Copyright 2023 Truwa Infotech</h2>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
